import { observable } from 'mobx';
import ErrorUtil from '../util/ErrorUtil';
import RootStore from './RootStore';
import BaseLoginStore from './BaseLoginStore';

export interface EmailLoginCredentials {
  emailAddress: string;
  password: string;
}

export default class EmailLoginStore extends BaseLoginStore {
  @observable accessor emailLoginCredentials: EmailLoginCredentials = { emailAddress: '', password: '' };

  constructor(rootStore: RootStore) {
    super(rootStore);
  }

  public async handleLogin() {
    await this.handleLoginTemplate('/email/auth', this.emailLoginCredentials, false);
  }

  public async verifyEmail(callback?: () => void) {
    if (this.routeStore.decodedParams['key']) {
      try {
        await this.handleLoginTemplate('/email/verify', { key: this.routeStore.decodedParams['key'] }, false, {}, callback);
      } catch (e: Error | string | any) {
        ErrorUtil.pushErrorToTeliaRumAndLog(e);
      }
    }
    return Promise.resolve();
  }
}
